<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>采购管理</el-breadcrumb-item>
                <el-breadcrumb-item>采购申请 - (由渠道或需求部门提出采购需求申请，经审核后转至采购订单)</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="90px" class="search-form">
            <el-row>
                <el-form-item label="关键词">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" placeholder="单号/申请人/部门" @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="status" placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="草稿" value="0"></el-option>
                        <el-option label="待审核" value="1"></el-option>
                        <el-option label="已审核" value="2"></el-option>
                        <el-option label="已转单" value="3"></el-option>
                        <el-option label="已作废" value="-1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="Plus" @click="add">新增</el-button>
            <el-button type="danger" icon="Delete" @click="deleter">删除</el-button>

            <el-dropdown style="margin-left:20px;">
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="download()">导出列表</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>

            <el-button type="primary" icon="Finished" @click="auditor()" style="margin-left: 80px;">单据审核</el-button>
            <el-button type="success" icon="Connection" @click="transfer()" style="margin-left: 15px;">转采购订单</el-button>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:toolbar="scope">
                <el-button @click="edit(scope.row)" link size="small" type="primary" icon="Edit">[编辑]</el-button>
                <el-button @click="view(scope.row)" link size="small" type="info" icon="View">[查看]</el-button>
            </template>

            <template v-slot:status="scope">
                <el-tag :type="(scope.row.status === 2) ? 'success' : (scope.row.status === 1) ? 'warning' : 'info'">
                    {{ statusText(scope.row.status) }}
                </el-tag>
            </template>

            <template v-slot:billDate="scope">
                <span>{{ $util.fmtDate(scope.row.billDate, 'yyyy-MM-dd') }}</span>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import { h } from 'vue';
import StaticDialog from '@/components/static-dialog.vue'
import BasicTable from '@/components/basic-table.vue'

export default {
    name: 'PurchaseRequisitionBill',
    components: { StaticDialog, BasicTable },
    data() {
        return {
            query: {
                keyword: '',
                columns: [
                    { type: "selection", width: "40" },
                    { type: 'index', label: '序号' },
                    { prop: 'billCode', label: '申请单号', sortable: true, searchable: true, width: '160' },
                    { prop: 'companyName', label: '公司', sortable: true, width: '180', showOverflowTooltip: true },
                    { prop: 'departmentName', label: '申请部门', sortable: true, width: '120', showOverflowTooltip: true },
                    { prop: 'applicantName', label: '申请人', sortable: true, width: '100', showOverflowTooltip: true },
                    { prop: 'billDate', label: '制单日期', type: 'template', sortable: true, width: '120' },
                    { prop: 'requirementDate', label: '需求日期', sortable: true, width: '140' },
                    { prop: 'totalQuantity', label: '总数量', sortable: true, width: '100' },
                    { prop: 'totalAmount', label: '总金额', sortable: true, width: '120' },
                    { prop: 'status', label: '状态', type: 'template', width: '100' },
                    { prop: 'remark', label: '备注', width: '160', showOverflowTooltip: true },
                    { type: 'toolbar', label: '操作', width: '140' }
                ],
                filters: [],
                sidx: 'billDate',
                sord: 'desc'
            },
            status: ''
        }
    },
    mounted() {
        this.$kaung.init(this.$options.name)
        this.fetchs()
    },
    methods: {
        statusText(s) {
            switch (s) {
                case 0: return '草稿'
                case 1: return '待审核'
                case 2: return '已审核'
                case 3: return '已转单'
                case -1: return '已作废'
                default: return ''
            }
        },

        builder() {
            let { data, records, total, ...params } = { ...this.query };

            // 重置并添加筛选条件
            params.filters = [];
            if (this.status) {
                params.filters.push({ name: "status", value: this.status, operate: 0 });
            }
            return params;
        },
        fetchs() {
            this.$kaung.search(this.builder()).then(res => {
                this.query = { ...res.data }
            })
        },
        download() {
            this.$kaung.export(this.builder()).then(res => {
                this.$notify({ title: '表格数据导出', message: res.content, type: res.type, duration: 10000 })
                window.location.href = process.env.VUE_APP_BASEURL + res.data
            })
        },
        add() {
            this.$router.push({ name: 'PurchaseRequisitionDetail' })
        },
        edit(row) {
            this.$router.push({ name: 'PurchaseRequisitionDetail', query: { id: row.id } })
        },
        view(row) {
            this.$router.push({ name: 'PurchaseRequisitionDetail', query: { id: row.id, mode: 'view' } })
        },
        deleter() {
            if (!this.$refs.table.chooseRow) {
                this.$message({ message: '请点击选择要删除的数据行', type: 'warning' })
                return
            }
            let that = this
            this.$confirm('此操作将删除本页选择数据, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                    this.$kaung.delete(that.$refs.table.chooseRow.id).then(res => {
                        if (res.code === 200) {
                            that.$message({ message: res.content, type: res.type })
                            that.fetchs()
                        }
                    })
                })
        },
        auditor(rowId) {
            let rowIds = [];

            rowId = rowId || '';
            if (rowId == null || rowId == '') {
                if (this.$refs.table.chooseRow)
                    rowIds.push(this.$refs.table.chooseRow.id);
                if (this.$refs.table.selectIds && this.$refs.table.selectIds.length > 0)
                    rowIds.push(...this.$refs.table.selectIds);
            } else {
                rowIds.push(rowId);
            }
            rowIds = [...new Set(rowIds)];//去重
            if (rowIds.length == 0) {
                this.$kaung.message('请选择或者勾选其中一个要操作的数据');
                return;
            }

            // 使用 Vue 的 h 函数来创建虚拟 DOM 节点
            const selectOptions = [
                { value: '1', label: '审核通过' },
                { value: '-1', label: '审核驳回' },
            ];
            let selectValue = selectOptions[0].value;
            this.$alert(h('div', {}, [
                h('select', {
                    style: 'width: 150px',
                    onChange: (event) => {
                        console.log('Selected:', event.target.value);
                        selectValue = event.target.value;
                    }
                }, selectOptions.map(option =>
                    h('option', { value: option.value }, option.label)
                )),
            ]), {
                title: '本次操作将作用于' + rowIds.length + '条数据，请确认',
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then((action) => {
                //console.log(action, selectValue); // 打印用户点击的是确认按钮还是取消按钮
                if (action == 'confirm') {
                    console.log(selectValue);
                    this.$kaung.fetch({
                        url: '/' + this.$options.name + '/Audit',
                        method: 'post',
                        params: {
                            ids: rowIds.join(','),
                            operate: selectValue,
                        }
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$kaung.success(res.content);
                            this.fetchs();
                        } else {
                            this.$kaung.error(res.content);
                        }
                    });
                }
            });
        },
        transfer(rowId) {
            let rowIds = [];

            rowId = rowId || '';
            if (rowId == null || rowId == '') {
                if (this.$refs.table.chooseRow)
                    rowIds.push(this.$refs.table.chooseRow.id);
                if (this.$refs.table.selectIds && this.$refs.table.selectIds.length > 0)
                    rowIds.push(...this.$refs.table.selectIds);
            } else {
                rowIds.push(rowId);
            }
            rowIds = [...new Set(rowIds)];//去重
            if (rowIds.length == 0) {
                this.$kaung.message('请选择或者勾选其中一个要操作的数据');
                return;
            }

            this.$confirm('确认将选中的' + rowIds.length + '条数据转移到采购订单, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                    this.$kaung.fetch({
                        url: '/' + this.$options.name + '/TransferToOrder',
                        method: 'post',
                        params: { ids: rowIds.join(',') }
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$kaung.success(res.content);
                            this.fetchs();
                        } else {
                            this.$kaung.error(res.content);
                        }
                    });
                })
        }
    }
}
</script>

<style scoped>
.toolbar {
    margin-bottom: 20px
}

.table {
    margin-top: 10px
}
</style>